import React from 'react';
import { AuthInputTextField, AuthInputNumberField, AuthSeparator } from '@/components';

interface DefaultsTabProps {
  advisorState: AdvisorProfile;
  errors: Partial<Record<keyof AdvisorProfile, boolean>>;
  handleAdvisorStateChange: (
    advisorKey: keyof AdvisorProfile,
  ) => (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export function DefaultsTab({ advisorState, errors, handleAdvisorStateChange }: DefaultsTabProps) {
  return (
    <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
      <AuthSeparator
        className="sm:col-span-6"
        text="Healthcare Inflation Settings"
      />
      <AuthInputNumberField
        id="defaultHealthcareInflationPercent"
        description="The default healthcare inflation rate used to calculate the client's healthcare costs."
        label="Default Healthcare Inflation Rate"
        value={advisorState.defaultHealthcareInflationPercent}
        onChange={handleAdvisorStateChange('defaultHealthcareInflationPercent')}
        placeholder="e.g. 5.4"
        unit="%"
        error={errors.defaultHealthcareInflationPercent}
        className="mt-0 sm:col-span-6"
        min={0}
        step={0.001}
        max={30}
        width="150px"
        required={false}
      />
      <AuthInputTextField
        id="defaultHealthcareInflationSourceText"
        label="Default Healthcare Inflation Source Text"
        description="Displayed text for the healthcare inflation source citation."
        value={advisorState.defaultHealthcareInflationSourceText ?? ''}
        onChange={handleAdvisorStateChange('defaultHealthcareInflationSourceText')}
        className="mt-0 sm:col-span-6"
        required={Boolean(advisorState.defaultHealthcareInflationPercent)}
        error={errors.defaultHealthcareInflationSourceText}
      />
      <AuthInputTextField
        id="defaultHealthcareInflationSourceUrl"
        label="Default Healthcare Inflation Source Link"
        description="URL for the healthcare inflation rate source."
        value={advisorState.defaultHealthcareInflationSourceUrl ?? ''}
        onChange={handleAdvisorStateChange('defaultHealthcareInflationSourceUrl')}
        className="mt-0 sm:col-span-6"
        required={false}
      />
    </div>
  );
}
